import React from "react";
import { BillStatus } from "@components/bills/BillStatus";
import {
    BILL_STATUS_VALUES,
    readBillStatusFilter,
} from "@helpers/billStatusFilter";
import { EMPTY_STATUS_FILTER } from "@helpers/statusFilter";
import { CombinedStatusFilter } from "../CombinedStatusFilter/CombinedStatusFilter";
import { BaseFilterProps } from "../../lib";

export const CombinedBillStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <CombinedStatusFilter
        name="billStatusFilterType"
        statusFilter={readBillStatusFilter(filters) ?? EMPTY_STATUS_FILTER}
        statuses={BILL_STATUS_VALUES}
        renderStatus={(status) => <BillStatus status={status} showText />}
        onChange={(billStatusFilter) =>
            onChange({
                billStatusFilter,
                billStatuses: undefined,
                externalBillStatuses: undefined,
            })
        }
    />
);
